import { Config } from "./Config.js";
import { Language } from "./Language.js";
import { IData, VOGroup, VOMedia, VOVideo } from "./Structure.js";

export class DataManager {

    public onSuccess = e5.Signal.create<[VOVideo]>();
    public onError = e5.Signal.create<[Error]>();
    public data: IData = null;

    public relatedVideos: VOVideo[] = [];

    private _dataUrl: string;
    private _defaultVideoId: number;

    constructor(dataUrl: string, defaultVideoId: number) {
        this._dataUrl = dataUrl;
        this._defaultVideoId = defaultVideoId;
    }

    public load(): void {
        var url = this._dataUrl;
        var ajax = new XMLHttpRequest();
        ajax.onreadystatechange = (e: Event) => {
            if (ajax.readyState == 4) {
                if (ajax.status == 200) {

                    this.data = JSON.parse(ajax.response);

                    Language.updateLabels(this.data.ui_labels);

                    for (var config of this.data.config) {
                        config.default_video = this.data.video.id(<any>config.default_video);

                        if (config.groups) {
                            for (var i = 0; i < config.groups.length; ++i) {
                                config.groups[i] = this.data.group.id(<any>config.groups[i]);
                            }
                        } else {
                            config.groups = [];
                        }
                    }

                    for (var group of this.data.group) {
                        if (group.videos) {
                            var videos: VOVideo[] = [];
                            for (var i = 0; i < group.videos.length; ++i) {
                                var id: number = <any>group.videos[i];
                                var v = this.data.video.id(id);
                                if (v)
                                    videos.push(v);
                                else
                                    console.warn(`Could not find video "${id}" for group "${group.title}".`);
                            }
                            group.videos = videos;
                        } else {
                            group.videos = [];
                        }
                    }

                    for (var video of this.data.video) {
                        this.prepareVideo(video);
                    }

                    Config.configTitle = e5.Url.params.get("config", "Default");
                    Config.init(e5.array.match(this.data.config, "title", Config.configTitle), this.data.video);

                    var hash: string = window.location.hash;
                    hash = hash.substring(1);

                    var video: VOVideo = null;
                    if (hash) {
                        var spl = hash.split("/");
                        video = this.getVideo(parseInt(spl[1]));
                    }

                    if (!video) {
                        video = this.getVideo(this._defaultVideoId);
                    }

                    if (!video) {
                        video = Config.defaultVideo;
                    }

                    if (Config.showUngroupedVideos) {

                        var videos = this.getRelatedVideos(video);
                        var groupVideos: VOVideo[] = [];
                        for (var group of Config.groups) {
                            if (group.videos) {
                                for (var v of group.videos) {
                                    if (groupVideos.indexOf(v) === -1)
                                        groupVideos.push(v);
                                    this.getRelatedVideos(v, videos);
                                }
                            }
                        }

                        var ungroupedVideos: VOVideo[] = [];
                        for (var v of videos) {
                            if (groupVideos.indexOf(v) === -1) {
                                console.warn("Ungrouped video found:", v.title, v.id);
                                ungroupedVideos.push(v);
                            }
                        }

                        if (ungroupedVideos.length > 0) {
                            var group: VOGroup = {
                                id: -1,
                                color: "#444444",
                                title: "Default Group",
                                videos: ungroupedVideos
                            };
                            this.data.group.unshift(group);
                            Config.groups.unshift(group);
                        }
                    }

                    this.onSuccess.dispatch(video);
                }
                else {
                    this.onError.dispatch(new Error("Leider konnten die Video-Daten nicht geladen werden"));
                }
            }
            else if (ajax.readyState == 0) {
                console.log("REQUEST NOT INIT");
            }
        }
        ajax.responseType = "text";
        ajax.open("get", url);
        ajax.send();
    }

    private getRelatedVideos(video: VOVideo, collection: VOVideo[] = []): VOVideo[] {
        if (!video || collection.indexOf(video) !== -1)
            return collection;

        collection.push(video);

        //Look for videos which are referenced by the current video.
        if (video.next_video) {
            this.getRelatedVideos(this.getVideo(video.next_video), collection);
        }
        if (video.markers) {
            for (var m of video.markers) {
                if (m.marker_action === "video") {
                    this.getRelatedVideos(this.getVideo(m.marker_video), collection);
                }
            }
        }

        //Look for videos which reference the current video.
        for (var v of this.data.video) {
            if (v.next_video === video.id) {
                this.getRelatedVideos(v, collection);
            }
            if (v.markers) {
                for (var m of v.markers) {
                    if (m.marker_action === "video" && m.marker_video === video.id) {
                        this.getRelatedVideos(v, collection);
                    }
                }
            }
        }

        return collection;
    }

    private prepareMedia(media: VOMedia): void {
        if (!media)
            return;

        // console.log(media);
        if (media.sizes && !media.sizes.full) {
            if (media.sizes.thumbnail) {
                media.sizes.full = media.sizes.thumbnail.replace("-150x150", "");
            }
        }
    }

    public prepareVideo(video: VOVideo): void {
        video.camera_x = parseFloat(<any>video.camera_x);
        video.camera_y = parseFloat(<any>video.camera_y);
        video.icon = parseFloat(<any>video.icon);

        video.markers = video.markers || [];

        this.prepareMedia(video.video_desktop);
        this.prepareMedia(video.video_mobile);

        if (!video.title_de && !video.title_en) {
            video.title_de = video.title;
            video.title_en = video.title;
        }

        for (var marker of video.markers) {
            marker.isInTime = true;
            marker.delegates = [];
            if (marker.marker_start_time == undefined)
                marker.marker_start_time = -1;
            if (marker.marker_end_time == undefined)
                marker.marker_end_time = -1;

            if (!marker.marker_icon) {
                var icon = 0;
                if (marker.marker_action == "video") {
                    if (this.data) {
                        var v = this.data.video.id(marker.marker_video);
                        if (v && v.icon) {
                            icon = v.icon;
                        }
                    }
                    if (!icon)
                        icon = 479;
                }
                else if (marker.marker_action == "text") {
                    icon = 463;
                }
                marker.marker_icon = icon;
            }
            else {
                marker.marker_icon = parseFloat(<any>marker.marker_icon);
            }
            marker.marker_x = parseFloat(<any>marker.marker_x);
            marker.marker_y = parseFloat(<any>marker.marker_y);
        }
    }

    public getVideo(id: number): VOVideo {
        return this.data ? this.data.video.id(id) : null;
    }
}